import { Seo } from '../../../../components/seo.js';
import { ROUTE_NAMES } from '@tsgecart/config';
import { ProductListing } from '../components/product-listing.js';

/** The "browse everything" entry point -- the shared listing UI with no `categoryId`/`search` pre-applied. */
export function ShopPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <Seo
        title="Shop"
        description="Browse fresh groceries and daily essentials."
        canonicalPath={ROUTE_NAMES.shop}
      />
      <h1 className="mb-6 text-2xl font-bold text-gray-900">Shop</h1>
      <ProductListing baseParams={{}} emptyStateDescription="Try adjusting your filters." />
    </div>
  );
}
